import React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DateFilter.css';

interface DateFilterProps {
  selectedDate: string;
  onDateChange: (date: string) => void;
  onApply: () => void;
  confirmedDates?: string[];
}

const DateFilter: React.FC<DateFilterProps> = ({ selectedDate, onDateChange, onApply, confirmedDates = [] }) => {
  const parseDate = (dateString: string): Date | null => {
    if (!dateString) return null;
    const [year, month, day] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
  };

  const formatDate = (date: Date | null): string => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = (date: Date | null) => {
    onDateChange(formatDate(date));
  };

  const confirmedDateObjects = confirmedDates
    .map(parseDate)
    .filter((d): d is Date => d !== null);

  const getDayClassName = (date: Date) => {
    const dateStr = formatDate(date);
    if (confirmedDates.includes(dateStr)) {
      return 'confirmed-date';
    }
    return '';
  };

  return (
    <>
      <label htmlFor="dateFilter">📅 날짜 선택:</label>
      <DatePicker
        id="dateFilter"
        selected={parseDate(selectedDate)}
        onChange={handleDateChange}
        dateFormat="yyyy-MM-dd"
        placeholderText="날짜를 선택하세요"
        highlightDates={confirmedDateObjects}
        dayClassName={getDayClassName}
        onKeyDown={(e) => e.preventDefault()}
      />
      <button className="btn-filter" onClick={onApply}>
        조회
      </button>
    </>
  );
};

export default DateFilter;
